import { query_product_in_record_list } from '@/api/mjstock-model';
import { reactive } from 'vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import defaultSlotList from '@/components/page-model/slotList';
import { TableColumn } from '@/typing';
import { SearchConfig } from '@/components/FormRender/RemoteModal/typing';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const config: SearchConfig = {
  settings: {
    name: '表单名称',
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '入库单编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写入库单编号',
    },
    {
      type: 'remotemodal',
      name: 's_product_id',
      label: '存货名称',
      disabled: false,
      placeholder: '请选择存货名称',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstock-sproduct',
    },
    {
      type: 'input',
      name: 'product_code',
      label: '产品批次号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写产品批次号',
    },
    {
      type: 'input',
      name: 'position',
      label: '库位',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写库位',
    },
    {
      type: 'rangepicker',
      name: 'end_date',
      label: '到期日期',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      showTime: false,
      placeholder: '请填写到期日期',
    },
    {
      type: 'remotemodal',
      name: 'from_shop_id',
      label: '调拨来源',
      disabled: false,
      placeholder: '请选择调拨来源',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'input',
      name: 'transfer_code',
      label: '调拨编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写调拨编号',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '执行门店',
      disabled: false,
      placeholder: '请选择执行门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'remoteselect',
      name: 'staff_id',
      label: '执行人',
      disabled: false,
      placeholder: '请选择执行人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    code: null,
    s_product_id: null,
    in_type: null,
    product_code: null,
    position: null,
    end_date: null,
    from_shop_id: null,
    transfer_code: null,
    shop_id: null,
    staff_id: null,
  }),
};
const search_options = {
  in_type: [
    { value: None, name: '全部' },
    { value: 1, name: '采购入库' },
    { value: 2, name: '盘盈入库' },
    { value: 3, name: '调拨入库' },
    { value: 4, name: '其他入库' },
  ],
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const columns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
    slots: { customRender: 'index' },
  },
  {
    title: 'ID',
    width: 150,
    dataIndex: 'id',
    fixed: false,
    checked: false,
  },
  {
    title: '入库类型',
    width: 150,
    dataIndex: 'in_type',
    fixed: false,
    checked: true,
  },
  {
    title: '入库单编号',
    width: 150,
    dataIndex: 'code',
    fixed: false,
    checked: true,
  },
  {
    title: '存货编号',
    width: 150,
    dataIndex: 's_product__code',
    fixed: false,
    checked: true,
  },
  {
    title: '存货名称',
    width: 150,
    dataIndex: 's_product__name',
    fixed: false,
    checked: true,
  },

  {
    title: '产品批次号',
    width: 150,
    dataIndex: 'product_code',
    fixed: false,
    checked: true,
  },
  {
    title: '库位',
    width: 150,
    dataIndex: 'position',
    fixed: false,
    checked: true,
  },
  {
    title: '入库数量',
    width: 150,
    dataIndex: 'in_num',
    fixed: false,
    checked: true,
  },
  {
    title: '存货单价',
    width: 150,
    dataIndex: 'single_price',
    fixed: false,
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '存货金额',
    width: 150,
    dataIndex: 'price',
    fixed: false,
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '生产日期',
    width: 150,
    dataIndex: 'product_date',
    fixed: false,
    checked: true,
  },
  {
    title: '到期日期',
    width: 150,
    dataIndex: 'end_date',
    fixed: false,
    checked: true,
  },
  {
    title: '调拨来源',
    width: 150,
    dataIndex: 'from_shop__name',
    fixed: false,
    checked: true,
  },
  {
    title: '调拨编号',
    width: 150,
    dataIndex: 'transfer_code',
    fixed: false,
    checked: true,
  },
  {
    title: '入库日期',
    width: 150,
    dataIndex: 'in_datetime',
    fixed: false,
    checked: true,
  },
  {
    title: '执行门店',
    width: 150,
    dataIndex: 'shop__name',
    fixed: false,
    checked: true,
  },
  {
    title: '执行人',
    width: 150,
    dataIndex: 'staff__name',
    fixed: false,
    checked: true,
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'create_time',
    fixed: false,
    checked: true,
  },
  {
    title: '单据状态',
    width: 150,
    dataIndex: 'is_active',
    fixed: false,
    checked: true,
  },
];

export default () => {
  return {
    searchConfig: config,
    searchConfigOptions: search_options,
    getData: query_product_in_record_list,
    columns: columns,
    slotList: defaultSlotList,
  };
};
